<template>
	<div>
		<navpage ref="navPage" :middle="true" pagename="categories"></navpage>

		<div id="content-page">
			<div class="row dynvibeRow">
				<div class="col-lg-12">
					<button @click="switchCat()" class="dynvibeButton">
						Manage
						{{ label == "category" ? "subcategory" : "category" }}
					</button>
				</div>
			</div>
			<div class="row dynvibeRow">
				<div class="col-xs-12">
					<button @click="addLabel()" class="dynvibeButton" style="border-radius: 12px; height: 25px">Add new {{ label }}</button>
				</div>
			</div>
			<div class="row dynvibeRow">
				<div class="col-lg-4">
					<input @keyup="search($event)" type="text" placeholder="Search ..." class="dynvibeInputText" v-model="searchQuery" />
				</div>
			</div>
			<div>
				<div class="row dynvibeRow" style="margin-top: 15px; position: relative">
					<div class="col-xs-12">
						<listmtcat :type="type" :key="key" ref="listmtcat" @innerclick="innerlistClik"></listmtcat>
						<div
							v-if="show && this.type == 'categories'"
							:key="key + 1"
							class="dynvibeBox"
							style="min-height: inherit; margin-top: 20px"
						>
							<p>
								<span style="text-transform: uppercase">Category :</span>
								<span class="dynvibeCategoryName">{{ this.category }}</span>
								<span @click="editLabel()" class="fas fa-edit" title="Edit name"></span>
							</p>
							<div style="margin-top: 15px">
								<span style="text-transform: uppercase">Select Subcategory to affect :</span>
								<select class="dynvibeSelect dynvibeCategoryAssign" style="min-width: 150px" v-model="subcatselected">
									<option v-for="(subcat, index) in this.data.allsubcats" :key="index" :value="subcat">
										{{ subcat }}
									</option>
								</select>
								<span @click="addSubCategory()" class="dynvibeAddSubCategory icon-plus"></span>
								<div v-if="this.data.category != undefined" class="dynvibeMastertagAssigned">
									<div
										class="dynvibeRuleTag"
										v-for="(subcat, index) in sortList(this.data.category.subcategories)"
										:key="'C' + index"
									>
										<div>
											<span>{{ subcat }}</span>
											<i @click="removeSubCategory(subcat)" class="dynvibeRuleSepRemove icon-x"></i>
										</div>
									</div>
								</div>
								<div style="margin-top: 15px">
									<button @click="saveLabel()" class="dynvibeButton" style="min-width: 100px">Save</button>
									<button @click="deleteLabel()" class="dynvibeButton" style="min-width: 100px; margin-left: 10px">
										Delete
									</button>
								</div>
							</div>
						</div>
						<div
							v-else-if="show && this.type == 'subcategories'"
							:key="key + 2"
							class="dynvibeBox"
							style="min-height: inherit; margin-top: 20px; position: relative"
						>
							<p>
								<span style="text-transform: uppercase">SubCategory :</span>
								<span class="dynvibeSubcategoryName">{{ this.data.label }}</span>
								<span @click="editLabel()" class="fas fa-edit" title="Edit name"></span>
							</p>
							<div class="col-lg-6">
								<p>
									<span style="text-transform: uppercase">Mastertags</span>
								</p>
								<div class="dynvibeMastertagAssigned" style="width: 310px; height: 210px; overflow: auto">
									<div v-for="(mt, index) in sortList(data.mastertags)" :key="index" class="dynvibeRuleTag">
										<div>
											<span>{{ mt }}</span>
											<i @click="removeMastertag(mt)" class="dynvibeRuleSepRemove icon-x"></i>
										</div>
									</div>
								</div>
								<div style="margin-top: 15px">
									Search Mastertag to add :
									<autocomplete
										:items="mastertags"
										v-model="mastertag"
										:setLabel="setMastertag"
										@changed="inputChange"
										@selected="mastertagSelected"
									>
										<template v-slot:content="{ item: item }">
											<span>{{ item.data.label }}</span>
										</template>
									</autocomplete>
								</div>
							</div>
							<div class="col-lg-6">
								<p>
									<span style="text-transform: uppercase">Categories</span>
								</p>
								<span style="text-transform: uppercase">Select category to affect :</span>
								<select class="dynvibeSelect dynvibeCategoryAssign" style="min-width: 150px" v-model="categoryselected">
									<option v-for="(cat, index) in this.data.allcats" :key="index" :value="cat">
										{{ cat }}
									</option>
								</select>
								<span @click="addCategory()" class="dynvibeAddSubCategory icon-plus"></span>
								<div class="dynvibeCategoriesAssigned" style="width: 310px; height: 210px; overflow: auto">
									<div
										v-for="(cat, index) in sortList(this.data.categories)"
										:key="index"
										class="dynvibeRuleTag affectedCategories"
									>
										<div>
											<span>{{ cat }}</span>
											<i @click="removeCategory(cat)" class="dynvibeRuleSepRemove icon-x"></i>
										</div>
									</div>
								</div>
							</div>
							<div style="margin-top: 15px">
								<button @click="saveLabel()" class="dynvibeButton" style="min-width: 100px">Save</button>
								<button @click="deleteLabel()" class="dynvibeButton" style="min-width: 100px; margin-left: 10px">
									Delete
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<confirm
				ref="confirminput"
				:color="confirmColor"
				:type="confirmType"
				:title="confirmTitle"
				@answerconfirm="treatConfirm($event)"
			>
				<template v-slot:confirm-body>
					{{ confirmMessage }}
					<div v-if="displayInput">
						<input v-model="inputValue" autofocus class="form-control" type="text" />
					</div>
					<div v-if="displaySelect">
						<p>In order to create a category you need to affect a subcategory to it</p>
						<select autofocus class="dynvibeSelect dynvibeSubCategoryDialog form-control" v-model="selectedConfirm">
							<option v-for="(subcat, index) in this.data.allsubcats" :key="'A' + index" :value="subcat">
								{{ subcat }}
							</option>
						</select>
						<span @click="addConfirm()" class="dynvibeAddDialog icon-plus"></span>
						<div class="dynvibeAssigned">
							<div v-for="(item, id) in listConfirm" :key="'Z' + id" class="dynvibeRuleTag">
								<div>
									<span>{{ item }}</span>
									<i @click="removeConfirm(item)" class="dynvibeRuleSepRemove icon-x"></i>
								</div>
							</div>
						</div>
					</div>
				</template>
			</confirm>
			<confirm ref="confirm" :color="confirmColor" :title="confirmTitle" :type="confirmType">
				<template v-slot:confirm-body>{{ confirmMessage }}</template>
			</confirm>
		</div>
	</div>
</template>
<script>
import navpage from "@/components/globalVue/Nav.vue";
import listmtcat from "@/components/globalVue/ListMtCatAdmin.vue";
import autocomplete from "@/components/categories/autocomplete.vue";
import confirm from "@/components/globalVue/Confirm.vue";
export default {
	name: "categories",
	data() {
		return {
			type: "categories",
			label: "category",
			category: "",
			categoryselected: "",
			subcatselected: "",
			selectedConfirm: "",
			listConfirm: [],
			key: 0,
			data: {
				label: "",
			},
			show: false,
			mastertag: {},
			mastertags: [],
			query: "",
			searchQuery: "",
			inputValue: "",
			confirmColor: "",
			confirmTitle: "",
			confirmType: "",
			confirmMessage: "",
			displayInput: false,
			displaySelect: false,
		};
	},
	components: {
		navpage: navpage,
		listmtcat: listmtcat,
		autocomplete: autocomplete,
		confirm: confirm,
	},
	watch: {
		inputValue(newVal) {
			this.inputValue = newVal;
		},
	},
	mounted() {
		this.getData("getCategory");
		this.$axios.interceptors.request.use(
			(config) => {
				return config;
			},
			(error) => {
				return Promise.reject(error);
			}
		);
		this.$axios.interceptors.response.use(
			(response) => {
				this.query = "";
				if (response.data.isOk) {
					this.$refs.confirm.close();
				}
				return response;
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},
	created() {},
	methods: {
		addConfirm() {
			this.listConfirm.indexOf(this.selectedConfirm) == -1
				? this.listConfirm.push(this.selectedConfirm)
				: this.confirmErrorModal("item already exists!");
		},
		removeConfirm(subcat) {
			let index = this.listConfirm.indexOf(subcat);
			index != -1 ? this.listConfirm.splice(index, 1) : this.confirmErrorModal("This item doesnt exist!");
		},
		treatConfirm(event) {
			if (event == "OK" && this.query != "") {
				this.$refs.confirminput.close();

				if (this.query == "addCategory") {
					if (this.inputValue.trim() == "") {
						this.confirmErrorModal("The category cannot be empty");
						return false;
					}
					if (this.listConfirm.length == 0) {
						this.confirmErrorModal("Cannot add/edit category without subcategory");
						return false;
					}

					let exists = false;
					this.$refs.listmtcat.data.forEach((element) => {
						if (element.data.label === this.inputValue) {
							exists = true;
						}
					});

					if (this.data.allsubcats.indexOf(this.inputValue) != -1) {
						this.confirmErrorModal("This category already exist as subcategory.");
						return false;
					} else if (exists) {
						this.confirmErrorModal("This category already exist.");
						return false;
					} else if (this.inputValue && this.listConfirm.length > 0) {
						this.confirmLoadingModal("open");
						this.$axios
							.post(
								this.$backendUrl + "addCategory",
								this.$Qs.stringify({
									category: this.inputValue,
									subcategories: this.listConfirm,
								})
							)
							.then((response) => {
								if (response.data.isOk) {
									this.confirmSuccessModal("Category " + this.inputValue + " has been added.");
									this.refreshListMtCat(this.type);
									this.inputValue = "";
								}
							});
					} else if (this.inputValue == "") {
						this.confirmErrorModal("Cannot add empty category name.");
					}
				} else if (this.query == "addSubcategory") {
					if (this.inputValue.trim() == "") {
						this.confirmErrorModal("The subcategory cannot be empty");
						return false;
					}
					this.confirmLoadingModal("open");
					this.$axios
						.post(
							this.$backendUrl + "addSubcategory",
							this.$Qs.stringify({
								subcategory: this.inputValue,
							})
						)
						.then((response) => {
							if (response.data.isOk) {
								this.confirmSuccessModal("Subcategory " + this.inputValue + " has been added.");
								this.refreshListMtCat(this.type);
								this.inputValue = "";
							} else {
								this.confirmErrorModal("This Subcategory already exist.");
								return false;
							}
						})
						.catch(() => {
							this.confirmErrorModal("Subcategory " + this.inputValue + " has not been edited.");
						});
				} else if (this.query == "editNameCategory" || this.query == "editNameSubcategory") {
					if (this.inputValue !== this.category) {
						//this.confirmLoadingModal("open");
						if (this.data.allsubcats.indexOf(this.inputValue) != -1) {
							this.confirmErrorModal("This category already exist as subcategory.");
							return false;
						}
						this.$axios
							.post(
								this.$backendUrl + this.query,
								this.$Qs.stringify({
									oldCategory: this.category,
									newCategory: this.inputValue,
								})
							)
							.then((response) => {
								if (response.data.isOk) {
									this.data.label = this.inputValue;
									this.confirmSuccessModal(this.label + " has been edited. " + this.category + " => " + this.inputValue);
									this.refreshListMtCat(this.type);
									this.category = this.inputValue;
								} else {
									this.confirmErrorModal(this.label + " " + this.inputValue + " already exists.");
								}
								this.inputValue = "";
							})
							.catch(() => {
								this.confirmErrorModal(this.label + " " + this.data.label + " has not been edited.");
							});
					}
				} else if (this.query == "updateCategory" || this.query == "updateSubcategory") {
					if (this.label == "category" && this.data.category.subcategories.length == 0) {
						this.confirmErrorModal(
							this.label + " " + this.category + " has not been edited. Cause : at least one subcategory is required ! "
						);
						return false;
					}
					let request =
						this.query === "updateCategory"
							? {
									mastertags: this.data.category.mastertags,
									label: this.data.category.label,
									subcategories: this.data.category.subcategories,
							  }
							: this.data;

					//this.confirmLoadingModal("open");

					this.$axios
						.post(this.$backendUrl + this.query, this.$Qs.stringify(request))
						.then((response) => {
							if (response.data.isOk) {
								this.confirmSuccessModal(this.label + " " + this.category + " has been edited.");
							}
						})
						.catch(() => {
							this.confirmErrorModal(this.label + " " + this.category + " has not been edited.");
						});
				} else if (this.query == "deleteCategories") {
					let data = this.type == "categories" ? { category: this.category } : { subcategory: this.category };

					this.confirmLoadingModal("open");
					this.$axios
						.post(this.$backendUrl + "deleteCategories", this.$Qs.stringify(data), {
							Accept: "application/json",
							"Content-Type": "application/json",
						})
						.then((response) => {
							if (response.data.isOk) {
								this.confirmSuccessModal(this.label + " " + this.category + " has been deleted.");
								this.refreshListMtCat(this.type);
								this.show = false;
							} else {
								this.confirmErrorModal(this.label + " " + this.category + " has not been deleted.");
							}
						});
				}
			}
		},
		mastertagSelected(mastertag) {
			this.mastertag = mastertag;
			this.data.mastertags.indexOf(mastertag) === -1
				? this.data.mastertags.push(mastertag)
				: this.confirmErrorModal("This item already exists");
		},
		setMastertag() {
			return this.mastertag;
		},
		inputChange(text) {
			let params = { type: "mastertags", search: text };
			this.$axios
				.get(this.$backendUrl + "getListMtCat", {
					params: params,
					paramsSerializer: function (params) {
						return this.$Qs.stringify(params, {
							arrayFormat: "brackets",
						});
					},
				})
				.then((response) => {
					this.mastertags = response.data.data;
				});
		},
		refreshListMtCat() {
			this.$refs.listmtcat.loadComponent();
		},
		addSubCategory() {
			this.data.category.subcategories.indexOf(this.subcatselected) === -1
				? this.data.category.subcategories.push(this.subcatselected)
				: this.confirmErrorModal("This item already exists");
		},
		addCategory() {
			this.data.categories.indexOf(this.categoryselected) === -1
				? this.data.categories.push(this.categoryselected)
				: this.confirmErrorModal("This item already exists");
		},
		removeSubCategory(subcat) {
			let index = this.data.category.subcategories.indexOf(subcat);
			index != -1 ? this.data.category.subcategories.splice(index, 1) : this.confirmErrorModal("This item doesnt exist");
		},
		removeCategory(cat) {
			let index = this.data.categories.indexOf(cat);
			index != -1 ? this.data.categories.splice(index, 1) : this.confirmErrorModal("This item doesnt exist");
		},
		removeMastertag(mastertag) {
			let index = this.data.mastertags.indexOf(mastertag);
			index != -1 ? this.data.mastertags.splice(index, 1) : this.confirmErrorModal("This item doesnt exist");
		},
		switchCat() {
			this.show = false;
			this.inputValue = "";
			this.query = "";
			this.searchQuery = "";
			if (this.label == "category") {
				this.type = "subcategories";
				this.label = "subcategory";
			} else {
				this.getData("getCategory");
				this.type = "categories";
				this.label = "category";
			}
			this.key++;
		},
		innerlistClik(value) {
			this.query = "";
			this.category = value.label;
			if (this.type == "categories") {
				this.getData("getCategory", {
					type: "cat",
					label: value.label,
				});
			} else {
				this.getData("getCategoryMastertag", {
					type: "subcat",
					label: value.label,
				});
			}
			this.show = true;
		},
		treatResponse(response) {
			this.data = response.data;
			if (this.data.allsubcats != undefined) {
				this.selectedConfirm = this.data.allsubcats[0];
				this.subcatselected = this.data.allsubcats[0];
			} else {
				this.categoryselected = this.data.allcats[0];
			}
		},
		search() {
			this.query = "";
			this.$refs.listmtcat.search(event.target.value);
		},
		addLabel() {
			this.displayInput = true;
			if (this.type != "categories") {
				this.confirmInputAddModal("Enter subcategory name");
				this.displaySelect = false;
				this.query = "addSubcategory";
				this.confirmTitle = "Add subcategory";
			} else {
				this.confirmInputAddModal("Enter category name");
				this.displaySelect = true;
				this.query = "addCategory";
				this.listConfirm = [];
				this.inputValue = "";
				this.confirmTitle = "Add category";
			}

			this.$refs.confirminput.open();
		},
		editLabel() {
			this.inputValue = this.category;
			this.confirmInputAddModal("Enter " + this.label + " name");
			if (this.type == "categories") {
				this.query = "editNameCategory";
				this.confirmTitle = "Edit category";
			} else {
				this.query = "editNameSubcategory";
				this.confirmTitle = "Edit subcategory";
			}

			this.displayInput = true;
			this.displaySelect = false;
			this.$refs.confirminput.open();
		},
		saveLabel() {
			this.confirmInputAddModal("Are you sure to save this " + this.label + " " + this.category + " ?");
			if (this.type == "categories") {
				this.query = "updateCategory";
				this.confirmTitle = "Save category";
			} else {
				this.query = "updateSubcategory";
				this.confirmTitle = "Save subcategory";
			}

			this.displayInput = false;
			this.displaySelect = false;
			this.$refs.confirminput.open();
		},
		deleteLabel() {
			this.confirmInputDeleteModal("Are you sure to delete this " + this.label + " " + this.category + " ?");
			this.confirmTitle = this.type == "categories" ? "Delete category" : "Delete subcategory";
			this.displayInput = false;
			this.displaySelect = false;
			this.query = "deleteCategories";
			this.$refs.confirminput.open();
		},
		sortList(v) {
			if (v === undefined || v.length === 0) {
				return v;
			}
			return v.sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));
		},
	},
};
</script>

<style>
.dynvibeButton {
	min-width: 180px;
}
.dynvibeInputText {
	min-width: 180px;
}
.vue-suggestion {
	top: 621px;
	left: 549.344px;
	width: 155px;
}

.vue-suggestion .vs__input-group .vs__input {
	display: block;
	margin: 0 auto;
	padding: 0.5rem 0.7rem;
	color: #464a4c;
	outline: none;
	background-color: #fff;
	background-image: none;
	background-clip: padding-box;
	border: 1px solid #cecece;
	border-radius: 0.25rem;
	transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}

.vue-suggestion .vs__input-group .vs__input:focus {
	border: 1px solid #023d7b;
}

.vue-suggestion .vs__list {
	width: 100%;
	text-align: left;
	border: none;
	border-top: none;
	max-height: 400px;
	overflow-y: auto;
	border-bottom: 1px solid #023d7b;
}

.vue-suggestion .vs__list .vs__list-item {
	cursor: pointer;
	background-color: #fff;
	padding: 10px;
}

.vue-suggestion .vs__list .vs__list-item:last-child {
	border-bottom: none;
}

.vue-suggestion .vs__list .vs__list-item:hover {
	background-color: #eee !important;
}
</style>
